import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PsychologyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"psychology"}/>
}
